import React, { useState } from "react";
import { Radio } from "lucide-react";
import { useAuth } from "../AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || "Unable to sign in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-rose-400/20 bg-slate-900 p-8 shadow-2xl">
        <Radio className="h-10 w-10 text-rose-400 mb-4" />
        <h1 className="text-2xl font-bold text-white">SwiftVox</h1>
        <p className="mt-2 text-sm text-slate-400">Reliable push-to-talk communication for field teams.</p>
        <label className="mt-6 block text-xs font-medium text-slate-300" htmlFor="swiftvox-email">Email</label>
        <input id="swiftvox-email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2.5 text-white outline-none focus:border-rose-400" />
        <label className="mt-4 block text-xs font-medium text-slate-300" htmlFor="swiftvox-password">Password</label>
        <input id="swiftvox-password" type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2.5 text-white outline-none focus:border-rose-400" />
        {error && <p role="alert" className="mt-3 text-sm text-red-400">{error}</p>}
        <button disabled={submitting} className="mt-6 w-full rounded-lg bg-rose-600 py-3 font-semibold text-white transition hover:bg-rose-500 disabled:opacity-60">
          {submitting ? "Signing in…" : "Sign in with SharpWithIt"}
        </button>
      </form>
    </main>
  );
}
